import clsx from "clsx";
import formatPrice from "@/core/helpers/formatPrice";

type Props = {
  image: string;
  value: number;
  text: string;
  title: string | null;
};

export default function NotificationTransactionIncrement({ image, value, text, title }: Props) {
  return (
    <>
      <div className="size-full rounded-lg bg-gradient-to-l to-transparent from-[#5fff69]/20 to-35%">
        <div
          className={clsx(
            "size-full bg-gradient-to-r from-white/6 to-transparent rounded-lg",
            title ? "p-[0.75rem]" : "px-[0.75rem] py-[0.5rem]",
          )}
        >
          <div className="flex items-center gap-[0.625rem]">
            <img src={image} alt="Icon" className="w-[1.5rem] h-[1.5rem]" />
            <div>
              {title && <p className="text-11 font-bold uppercase">{title}</p>}
              <p
                className={clsx(
                  "text-14 font-medium leading-none",
                  title ? "text-white/75" : "text-white",
                )}
              >
                {text}: <span className="font-bold text-[#5FFF69]">+{formatPrice(value)} ₽</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <img
        src="/svg/notifications-transaction/arrow-green-dark.svg"
        alt="Icon"
        className="absolute top-[0.125rem] right-[1.19rem] w-[1.966rem] h-[2.47rem]"
      />
      <img
        src="/svg/notifications-transaction/arrow-green.svg"
        alt="Icon"
        className="absolute top-[0.125rem] right-[0.786rem] w-[1.43rem] h-[1.85rem]"
      />
      <span className="absolute top-0 right-0 w-[calc(100%-0.125rem)] h-full bg-[linear-gradient(0deg,transparent,#5fff6940,#5fff69,#5fff6940,transparent)] border-r-[0.125rem] border-transparent rounded-lg mask-padding pointer-events-none" />
    </>
  );
}
